export const shouldRetry = (error: Error): boolean => {
	if ('statusCode' in error && typeof error.statusCode === 'number') {
		return [502, 503, 504].includes(error.statusCode);
	}
	return false;
};
